import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductIdEnum } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-images-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ins-insurance-images [insurances]="insurances">
        </ins-insurance-images>
    `,
})
export class InsuranceImagesContainer {
    @Input() insurances: ProductIdEnum[];
}
